module.exports = __webpack_public_path__ + "img/avatar.a7cca215.png";